import api from '../api'
import * as mutationTypes from './mutation-types'

const getters = {
  getUserById: (state) => (id) => {
    return state.users ? state.users.find((user) => user.id === id) : undefined
  },
}

const mutations = {
  [mutationTypes.SET_USERS](state, users) {
    state.users = users
  },
}

const actions = {
  async fetchUsersForFirm({ commit }) {
    const data = await api.fetchUsers()

    commit(mutationTypes.SET_USERS, data['users'])
  },
}

export default {
  state() {
    return {
      users: null,
    }
  },
  getters,
  mutations,
  actions,
}
